"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_components_1 = require("@securityproducts/core-components");
var React = __importStar(require("react"));
// @ts-ignore
var react_tippy_1 = require("react-tippy");
var archiveDateRange_1 = require("./archive-date-range/archiveDateRange");
var customDateRange_1 = require("./custom-date-range/customDateRange");
var datePickerCard_i18n_1 = require("./datePickerCard.i18n");
var datePickerCard_styles_1 = require("./datePickerCard.styles");
var dateRange_service_1 = require("./dateRange.service");
var datePickerRange_1 = require("./range/datePickerRange");
function DatePickerCard(props) {
    var dateAndTime = core_components_1.DateAndTimeStore.getInstance();
    var isFirst = React.useRef(true);
    var containerNode = React.useRef(null);
    var _a = React.useState(props.forceShowCustom ? props.forceShowCustom : false), showCustom = _a[0], setShowCustom = _a[1];
    var _b = React.useState(props.currentRange === "Archived"), showArchivedReports = _b[0], setShowArchivedReports = _b[1];
    var _c = React.useState(props.display || "DAYS"), display = _c[0], setDisplay = _c[1];
    var _d = React.useState({
        fromDate: getFromDate(),
        toDate: getToDate(),
    }), dateRange = _d[0], setRange = _d[1];
    var customDateRange = React.useState(getCustomDateRange(props.currentRange, props.fromDate, props.toDate, dateAndTime))[0];
    var _e = React.useState(false), showArchivedTooltip = _e[0], setShowArchivedTooltip = _e[1];
    var _f = React.useState(false), pickerIsShowing = _f[0], setPickerIsShowing = _f[1];
    var strings = core_components_1.useLocalisation(datePickerCard_i18n_1.datePickerCardTranslations, props.language);
    var dateRangeService = dateRange_service_1.DateRangeService.getInstance(props.newRangeBehaviour);
    function getFromDate() {
        if (props.archiveMode) {
            return props.archiveDataFrom;
        }
        if (props.fromDate) {
            return props.fromDate;
        }
        return dateAndTime.todayStart;
    }
    function getToDate() {
        if (props.toDate) {
            return props.toDate;
        }
        return dateAndTime.todayEnd;
    }
    function applyDateTime() {
        props.setDateTime({
            fromDate: dateRange.fromDate,
            toDate: dateRange.toDate,
        });
        props.setDisplay(display);
    }
    function handleClick(e) {
        if (containerNode.current.contains(e.target)) {
            return;
        }
        props.setShowDatePicker(false);
    }
    React.useEffect(function () {
        document.addEventListener("mousedown", handleClick, false);
        return function () {
            document.removeEventListener("mousedown", handleClick, false);
        };
    }, []);
    React.useEffect(function () {
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        if (dateRange.fromDate && dateRange.toDate) {
            applyDateTime();
        }
    }, [dateRange]);
    React.useEffect(function () {
        if (pickerIsShowing) {
            var fromDateIsInRange = props.fromDate >= props.archiveDataFrom ||
                props.fromDate <= props.callSummaryDataFrom;
            var toDateIsInRange = props.toDate >= props.archiveDataFrom || props.toDate <= props.callSummaryDataFrom;
            setShowArchivedTooltip(fromDateIsInRange || toDateIsInRange);
        }
        else {
            setShowArchivedTooltip(false);
        }
    }, [dateRange, pickerIsShowing]);
    React.useEffect(function () {
        setRange({
            fromDate: props.fromDate,
            toDate: props.toDate,
        });
    }, ["" + props.fromDate + props.toDate]);
    var archivedReportsTooltip = (React.createElement("div", { className: datePickerCard_styles_1.archivedTooltip },
        React.createElement("div", { className: datePickerCard_styles_1.archivedTooltipContent },
            React.createElement("div", null,
                strings.archivedReportsTooltipOne,
                " ",
                React.createElement("span", { className: datePickerCard_styles_1.red }, strings.red),
                " ",
                strings.archivedReportsTooltipTwo))));
    function closeSelf() {
        // horrible little hack but there is modified version of the picker
        // running in Analytics that improves on this logic. Once that one
        // has been battle tested enough we can replace this one so there's
        // not much point in taking the time to fix this properly.
        setTimeout(function () { return props.setShowDatePicker(false); }, 0);
    }
    function selectToday() {
        setRange(dateRangeService.today.range);
        setDisplay("HOURS");
        props.setArchiveMode(false);
        props.setCurrentRange(dateRangeService.today.label);
        setShowCustom(false);
        closeSelf();
    }
    function selectYesterday() {
        setRange(dateRangeService.yesterday.range);
        setDisplay("HOURS");
        props.setArchiveMode(false);
        props.setCurrentRange(dateRangeService.yesterday.label);
        setShowCustom(false);
        closeSelf();
    }
    function selectLastThreeDays() {
        setRange(dateRangeService.lastThreeDays.range);
        setDisplay("DAYS");
        props.setArchiveMode(false);
        props.setCurrentRange(dateRangeService.lastThreeDays.label);
        setShowCustom(false);
        closeSelf();
    }
    function selectLastWeek() {
        setRange(dateRangeService.lastWeek.range);
        setDisplay("DAYS");
        props.setArchiveMode(false);
        props.setCurrentRange(dateRangeService.lastWeek.label);
        setShowCustom(false);
        closeSelf();
    }
    function selectLastTwoWeeks() {
        if (props.newRangeBehaviour) {
            setRange(dateRangeService.lastFourteenDays.range);
        }
        else {
            setRange(dateRangeService.lastTwoWeeks.range);
        }
        setDisplay("DAYS");
        props.setArchiveMode(false);
        props.setCurrentRange(props.newRangeBehaviour
            ? dateRangeService.lastFourteenDays.label
            : dateRangeService.lastTwoWeeks.label);
        setShowCustom(false);
        closeSelf();
    }
    function selectLastMonth() {
        setRange(dateRangeService.lastMonth.range);
        props.setCurrentRange(dateRangeService.lastMonth.label);
        setDisplay("DAYS");
        props.setArchiveMode(false);
        setShowCustom(false);
        closeSelf();
    }
    function showCustomDatePicker() {
        setShowArchivedReports(false);
        setShowCustom(!showCustom);
    }
    function showArchivedDatePicker() {
        setShowCustom(false);
        setShowArchivedReports(!showArchivedReports);
    }
    var customClass = getCustomClass(showCustom, showArchivedReports);
    var archiveClass = getArchiveClass(showCustom, showArchivedReports);
    return (React.createElement("div", { className: datePickerCard_styles_1.container, ref: containerNode },
        React.createElement("div", { id: "date-range-options", className: datePickerCard_styles_1.wrapper },
            props.showToday && (React.createElement(datePickerRange_1.DatePickerRange, { label: strings.today, range: dateRangeService.today, currentRange: props.currentRange, comparison: "hourlyComparison", onClick: selectToday, language: props.language })),
            props.showYesterday && (React.createElement(datePickerRange_1.DatePickerRange, { label: strings.yesterday, range: dateRangeService.yesterday, currentRange: props.currentRange, comparison: "hourlyComparison", onClick: selectYesterday, language: props.language })),
            React.createElement(datePickerRange_1.DatePickerRange, { label: strings.lastThreeDays, range: dateRangeService.lastThreeDays, currentRange: props.currentRange, comparison: "dailyComparison", onClick: selectLastThreeDays, language: props.language }),
            React.createElement(datePickerRange_1.DatePickerRange, { label: strings.lastWeek, range: dateRangeService.lastWeek, currentRange: props.currentRange, comparison: "dailyComparison", onClick: selectLastWeek, language: props.language }),
            React.createElement(datePickerRange_1.DatePickerRange, { label: props.newRangeBehaviour ? strings.lastFourteenDays : strings.lastTwoWeeks, range: props.newRangeBehaviour
                    ? dateRangeService.lastFourteenDays
                    : dateRangeService.lastTwoWeeks, currentRange: props.currentRange, comparison: "dailyComparison", onClick: selectLastTwoWeeks, language: props.language }),
            React.createElement(datePickerRange_1.DatePickerRange, { label: strings.lastMonth, range: dateRangeService.lastMonth, currentRange: props.currentRange, comparison: "dailyComparison", onClick: selectLastMonth, language: props.language }),
            React.createElement("div", { className: datePickerCard_styles_1.customOptions },
                React.createElement(datePickerRange_1.DatePickerRange, { label: strings.custom, range: dateRangeService.custom, currentRange: props.currentRange, comparison: undefined, onClick: showCustomDatePicker, className: customClass, language: props.language }),
                props.archiveDataFrom && (showCustom || showArchivedReports) && (React.createElement(react_tippy_1.Tooltip, { open: showArchivedTooltip, arrow: true, html: archivedReportsTooltip, theme: "blue", popperOptions: {
                        modifiers: {
                            preventOverflow: {
                                enabled: false,
                            },
                        },
                    }, hideOnClick: false },
                    React.createElement(datePickerRange_1.DatePickerRange, { label: strings.archivedReports, range: dateRangeService.archived, currentRange: props.currentRange, comparison: undefined, onClick: showArchivedDatePicker, className: archiveClass, language: props.language })))),
            showCustom && (React.createElement("div", { className: datePickerCard_styles_1.archiveWrapper },
                React.createElement(customDateRange_1.CustomDateRange, { from: customDateRange.fromDate, to: customDateRange.toDate, display: display, setRange: setRange, setDisplay: setDisplay, setArchiveMode: props.setArchiveMode, closePicker: function () { return props.setShowDatePicker(false); }, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, pickerIsShowing: setPickerIsShowing, showArchivedTooltip: setShowArchivedTooltip, language: props.language, setCurrentRange: props.setCurrentRange }))),
            showArchivedReports && (React.createElement("div", { className: datePickerCard_styles_1.archiveWrapper },
                React.createElement(archiveDateRange_1.ArchiveDateRange, { from: customDateRange.fromDate, to: customDateRange.toDate, setDisplay: setDisplay, setRange: setRange, setArchiveMode: props.setArchiveMode, closePicker: function () { return props.setShowDatePicker(false); }, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, language: props.language, setCurrentRange: props.setCurrentRange }))))));
}
exports.DatePickerCard = DatePickerCard;
function formatDate(date, language) {
    var lang = language ? language : core_components_1.getBrowserLanguage();
    if (date) {
        return core_components_1.customLocale(date, lang, {
            month: "short",
            day: "2-digit",
            year: "numeric",
        });
    }
    else {
        return undefined;
    }
}
exports.formatDate = formatDate;
function getCustomClass(showCustom, showArchivedReports) {
    if (showCustom) {
        if (showArchivedReports) {
            return datePickerCard_styles_1.labelSecondaryActive;
        }
        else {
            return datePickerCard_styles_1.labelActive;
        }
    }
    return datePickerCard_styles_1.label;
}
function getArchiveClass(showCustom, showArchivedReports) {
    if (showCustom) {
        if (showArchivedReports) {
            return datePickerCard_styles_1.labelActive;
        }
        else {
            return datePickerCard_styles_1.labelSecondaryActive;
        }
    }
    return datePickerCard_styles_1.label;
}
function getCustomDateRange(currentRange, fromDate, toDate, dateAndTime) {
    if (currentRange === "Custom" || currentRange === "Archived") {
        return {
            fromDate: fromDate ? fromDate : dateAndTime.todayStart,
            toDate: toDate ? toDate : dateAndTime.todayEnd,
        };
    }
    else {
        return {
            fromDate: dateAndTime.todayStart,
            toDate: dateAndTime.todayEnd,
        };
    }
}
